<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tocchaptitle"><a id="contents"></a><span class="small">The</span> C<span class="small">OMMUNITY</span> <span class="small">of</span> K<span class="small">INDNESS</span></h1>
<p class="toc"><a href="#/06_chapter01#c1">1 Longing for Connection</a></p>
<p class="toc"><a href="#/07_chapter02#c2">2 Remembering the Kind Embrace of Community</a></p>
<p class="toc"><span href="#/08_chapter03#c3" title="Link target outside of Sample">3 The Path to Community</span></p>
<p class="toc"><span href="#/09_chapter04#c4" title="Link target outside of Sample">4 The Power of Kindness</span></p>
<p class="toc"><span href="#/10_chapter05#c5" title="Link target outside of Sample">5 The Transformative Nature of Community</span></p>
<p class="toc"><span href="#/11_chapter06#c6" title="Link target outside of Sample">6 Experiencing the Kind Caress of Community</span></p>
<p class="toc"><span href="#/12_chapter07#c7" title="Link target outside of Sample">7 Only Kindness Allows for Community</span></p>
<p class="toc"><span href="#/13_chapter08#c8" title="Link target outside of Sample">8 The Practice of Community</span></p>
<p class="toc"><span href="#/14_chapter09#c9" title="Link target outside of Sample">9 Giving from Plenty</span></p>
<p class="toc"><span href="#/15_chapter10#c10" title="Link target outside of Sample">10 We Are a Community of Kindness</span></p>
<p class="toc"><span href="#/16_acknowldgments#ack" title="Link target outside of Sample">A<span class="small">CKNOWLEDGMENTS</span></span></p>
<p class="toc"><span href="#/17_abouttherandom#atrakf" title="Link target outside of Sample">A<span class="small">BOUT THE</span> R<span class="small">ANDOM</span> A<span class="small">CTS OF</span> K<span class="small">INDNESS</span> F<span class="small">OUNDATION</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_contents.vue?13075584